import React from "react"

import Layout from "../components/layout"

const IndexPage = () => <Layout></Layout>

export const contentLinkFields = graphql`
  fragment ContentLinkFields on ContentfulContent {
    headline
    subtitle
    content {
      raw
      references {
        __typename
      }
    }
  }
`

export default IndexPage
